export default {
  head: {
    title: 'SMS operations billing',
    action: {
      create: {
        tooltip: 'Create new SMS report'
      },
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search SMS billing operation'
    },
    details: {
      title: 'Operation details'
    }
  }
};
